import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/logs',
    name: 'logs',
    component: () => lazyLoadView(import('@views/admin/operator/loket/List.vue')),
    meta: {
      title: 'Riwayat Aktivitas',
    },
  },
];
